export type LegalSection = {
  heading: string
  paragraphs: string[]
}

export type LegalDocument = {
  id: 'privacidad' | 'terminos'
  title: string
  updated: string
  intro: string
  sections: LegalSection[]
}

export const privacyPolicy: LegalDocument = {
  id: 'privacidad',
  title: 'Política de Privacidad',
  updated: 'Última actualización: 10 de septiembre de 2026',
  intro:
    'Esta política explica qué datos recogemos cuando visitas o compras en Curly Seducción, para qué los usamos y qué control tienes sobre ellos.',
  sections: [
    {
      heading: '1. Datos que recogemos',
      paragraphs: [
        'Datos que nos das tú: nombre y correo electrónico al realizar la compra, y el país de facturación exigido por la pasarela de pago.',
        'Datos que se generan solos: dirección IP aproximada, tipo de dispositivo, navegador, páginas vistas y tiempo de permanencia. Nunca recogemos fotos de tu cabello, datos de salud ni información sobre menores.',
      ],
    },
    {
      heading: '2. Datos de pago',
      paragraphs: [
        'No almacenamos números de tarjeta. El cobro lo procesa íntegramente una pasarela de pago certificada PCI DSS, que nos devuelve únicamente la confirmación de la transacción y los últimos cuatro dígitos para efectos de facturación.',
      ],
    },
    {
      heading: '3. Para qué usamos tus datos',
      paragraphs: [
        'Para entregarte el enlace de descarga del material comprado.',
        'Para enviarte correos relacionados con el método. Cada envío incluye un enlace de baja que surte efecto de inmediato.',
        'Para medir de forma agregada qué secciones de la página resultan útiles y mejorar el contenido.',
      ],
    },
    {
      heading: '4. Cookies',
      paragraphs: [
        'Usamos cookies técnicas necesarias para mantener la sesión de compra y cookies analíticas anónimas. Puedes bloquearlas desde la configuración de tu navegador; el acceso al material seguirá funcionando.',
      ],
    },
    {
      heading: '5. Con quién se comparten',
      paragraphs: [
        'Solo con los proveedores necesarios para operar: la pasarela de pago, la plataforma de envío de correos y el servicio de alojamiento del material. Ninguno puede usar tus datos para fines propios y no vendemos ni cedemos información a terceros con fines publicitarios.',
      ],
    },
    {
      heading: '6. Conservación',
      paragraphs: [
        'Conservamos los datos de compra durante el plazo legal de conservación fiscal. Los datos de marketing se eliminan al darte de baja.',
      ],
    },
    {
      heading: '7. Tus derechos',
      paragraphs: [
        'Puedes solicitar acceso, rectificación, eliminación, portabilidad u oposición al tratamiento de tus datos en cualquier momento desde el enlace de gestión incluido en el correo de tu compra. Las solicitudes se resuelven en un máximo de 30 días.',
      ],
    },
  ],
}

export const termsOfService: LegalDocument = {
  id: 'terminos',
  title: 'Términos del Servicio',
  updated: 'Última actualización: 10 de septiembre de 2026',
  intro:
    'Al comprar o utilizar Curly Seducción aceptas las condiciones descritas a continuación. Léelas antes de completar tu pago.',
  sections: [
    {
      heading: '1. Qué estás comprando',
      paragraphs: [
        'Curly Seducción es un producto digital de carácter educativo: una guía escrita de 70 páginas en PDF y tres materiales complementarios. No incluye videos, asesoría personalizada, consultas individuales ni productos físicos.',
      ],
    },
    {
      heading: '2. Licencia de uso',
      paragraphs: [
        'Recibes una licencia personal e intransferible para consultar el material. No está permitido copiarlo, revenderlo, compartirlo en grupos, subirlo a plataformas de descarga ni usar su contenido para formar a terceros a cambio de dinero.',
        'El incumplimiento de esta cláusula permite revocar el acceso sin reembolso.',
      ],
    },
    {
      heading: '3. Precio y pago',
      paragraphs: [
        'El precio promocional vigente es de $6.39 USD en un pago único, frente al precio regular de $27.00 USD. No hay suscripciones, renovaciones automáticas ni cargos recurrentes de ningún tipo.',
      ],
    },
    {
      heading: '4. Entrega del acceso',
      paragraphs: [
        'El acceso se envía automáticamente al correo indicado en la compra, normalmente en menos de cinco minutos. Es responsabilidad del comprador escribir correctamente su dirección de correo y revisar la carpeta de spam.',
      ],
    },
    {
      heading: '5. Garantía y reembolsos',
      paragraphs: [
        'Dispones de 30 días naturales desde la compra para solicitar la devolución íntegra del importe, sin necesidad de justificar el motivo. La solicitud se tramita desde el enlace de gestión incluido en el correo de compra y el reembolso se emite al mismo método de pago en un plazo de 5 a 10 días hábiles.',
      ],
    },
    {
      heading: '6. Resultados',
      paragraphs: [
        'El método describe técnicas de cuidado capilar. Los resultados dependen del tipo de cabello, su estado inicial y la constancia de cada persona, por lo que no se garantiza un resultado concreto ni un plazo determinado.',
        'El contenido no constituye consejo médico ni dermatológico. Ante caída del cabello, irritación o afecciones del cuero cabelludo, consulta a un profesional de la salud.',
      ],
    },
    {
      heading: '7. Cambios en el contenido',
      paragraphs: [
        'Podemos revisar o reorganizar el material en futuras ediciones. La compra da derecho a la versión vigente en la fecha en que se realizó, sin que ello implique la entrega de ediciones posteriores.',
        'También podemos modificar estos términos; los aplicables a tu compra son los vigentes en el momento del pago.',
      ],
    },
  ],
}
